export const APP_STAGE = process.env.REACT_APP_STAGE as "local" | "develop" | "staging" | "production";
export const APP_BADGE: string | undefined = process.env.REACT_APP_BADGE;
export const APP_BADGE_DISABLED = !!process.env.REACT_APP_BADGE_DISABLE;
